function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
}

$(document).ready(function() {
  $('#submitsend').click(function(event) {

    var name = $('#inputName').val();
    if(!name){
      alert("Please enter the name");
      $('#inputName').focus();
      return false;
    }
    var email = $('#inputEmail').val();
    if(!email){
      alert("Please enter the email");
      $('#inputEmail').focus();
      return false;
    }
    
    if(!isValidEmailAddress(email))
    {
      alert("Please enter a valid email id");
      $('#inputEmail').focus();
      return false;
    }
    
    var phone = parseInt($('#inputPhone').val());    
    if(!phone){
      alert("Please enter the phone");
      $('#inputPhone').focus();
      return false;
    }
    var country = $('#selectCountry').val();
    var subject = $('#selecttype').val();
    var message = $('#textareaMessage').val();
    if(!message){
      alert("Please enter the message");
      $('#textareaMessage').focus();
      return false;
    }
    $('#contact_form').submit();
    /*var settings = {
      "url": "https://westoncorp.freshdesk.com/api/v2/tickets",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Content-Type": "application/json",
        "Authorization": "Basic ZW5xdWlyaWVzQHdlc3Rvbi5jb20uc2c6Y3N0b24yMDIwIQ==",
        "Cookie": "_x_w=38_3; _x_m=x_c"
      },
      "data": JSON.stringify({"description":message,"subject":subject,"email":email,"priority":1,"status":2, "custom_fields" : { "cf_name" : name, "cf_phone": phone, "cf_country": country }}),
    };
    // ,"cc_emails":["srinivasan@techcmantix.com","arun.raj@solstium.net"]
    $.ajax(settings).done(function (response) {
      
      console.log(response);

    });*/


  });
});